import factory from './icon';
import Svg from './glyphs/information-icon.svg';

export default factory(Svg);
